import { createContext } from 'react';

export const currentDateDefaultValue = {
	currentDate: new Date(),
	currentDateLastUpdated: new Date(),
	updateCurrentDate: () => {},
};

// Context that keeps the current date in a central place (can be modified to test different dates in UI)
const CurrentDateContext = createContext<{
	currentDate: Date;
	currentDateLastUpdated: Date;
	updateCurrentDate: (date: Date) => void;
}>(currentDateDefaultValue);

export default CurrentDateContext;
